import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiCall } from '../utils/api';

function AddModule() {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [runbookId, setRunbookId] = useState(null);
  const [modules, setModules] = useState([]);
  const [selectedModules, setSelectedModules] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Get the runbook ID passed from the EditRunbook page
    if (location.state && location.state.runbook_id) {
      setRunbookId(location.state.runbook_id);
    }

    const fetchAllModules = async () => {
        try {
            const data = await apiCall('/modules');
            setModules(data);
        } catch (err) {
            console.error("Failed to fetch modules", err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    fetchAllModules();
  }, [location.state]);

  const handleCheckboxChange = (moduleId) => {
    setSelectedModules(prev => {
      const newSelected = new Set(prev);
      if (newSelected.has(moduleId)) {
        newSelected.delete(moduleId);
      } else {
        newSelected.add(moduleId);
      }
      return newSelected;
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (selectedModules.size === 0) {
        alert("Please select at least one module.");
        return;
    }

    try {
        await apiCall(`/runbooks/${runbookId}/modules`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ selected_modules: Array.from(selectedModules) }),
        });
        
        alert('Modules added successfully!');
        // Navigate back to the edit page to see the updated list
        navigate(`/edit_runbook/${runbookId}`);
    } catch(err) {
        console.error(err);
        alert(err.message || "Failed to add modules");
    }
  };

  if(loading) return <div className="container mt-4">Loading available modules...</div>;
  if(error) return <div className="container mt-4 alert alert-danger">{error}</div>;

  return (
    <div className="container mt-4">
      <h1>Add Modules to Runbook: {runbookId}</h1>
      <form onSubmit={handleSubmit}>
        <table className="table table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th>Select</th>
              <th>Module ID</th>
              <th>Module Description</th>
            </tr>
          </thead>
          <tbody>
            {modules.map((moduleItem) => (
              <tr key={moduleItem['Module ID']}>
                <td>
                  <input
                    type="checkbox"
                    value={moduleItem['Module ID']}
                    checked={selectedModules.has(moduleItem['Module ID'])}
                    onChange={() => handleCheckboxChange(moduleItem['Module ID'])}
                  />
                </td>
                <td>{moduleItem['Module ID']}</td>
                <td>{moduleItem['Module Description']}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="d-flex justify-content-end mt-3">
            <button type="submit" className="btn btn-primary">✔ Add Selected Modules</button>
            <button type="button" onClick={() => navigate(-1)} className="btn btn-secondary mx-2">❌ Cancel</button>
        </div>
      </form>
    </div>
  );
}

export default AddModule;